import { memo } from 'react';
import { Box, Grid, Skeleton } from '@mui/material';
import { moneyFullFormat } from 'components/Utils/format';
import useSimulacaoBoxHook from '../../hooks/useSimulacaoBoxHook';
import './SimulacaoBox.scss';

const SimulacaoBox = ({ buscarSimulacaoResumo, setLiberarBtnProsseguir }) => {
  const { loadingSimulacao, dadosSimulacaoResumo } = useSimulacaoBoxHook({
    buscarSimulacaoResumo,
    setLiberarBtnProsseguir
  });

  return (
    <Box>
      <Grid container>
        <Grid item xs={12} md={12} className="grid-simulacao-card">
          {!loadingSimulacao && (
            <Box className="simulacao-card">
              <Box className="simulacao-card-content">
                <Box className="box-informacoes">
                  <Box className="box-titulo-simulacao">Resumo da simulação</Box>
                  <Box className="box-itens mt-3">
                    <Grid container>
                      <Grid item xs={12} md={2}>
                        <Box className="titulo-simulacao">Nº de títulos selecionados</Box>
                        <Box className="valor-simulacao">{dadosSimulacaoResumo.QTDTITULOS}</Box>
                      </Grid>
                      <Grid item xs={12} md={2}>
                        <Box className="titulo-simulacao">Prazo médio</Box>
                        <Box className="valor-simulacao">
                          {dadosSimulacaoResumo.PRAZOMEDIO && (
                            <>{parseInt(dadosSimulacaoResumo.PRAZOMEDIO)} dias</>
                          )}
                          {!dadosSimulacaoResumo.PRAZOMEDIO && <> - - </>}
                        </Box>
                      </Grid>
                      <Grid item xs={12} md={3}>
                        <Box className="titulo-simulacao">Valor total</Box>
                        <Box className="valor-simulacao">
                          {moneyFullFormat(dadosSimulacaoResumo.VLRBRUTO)}
                        </Box>
                      </Grid>
                      <Grid item xs={12} md={2}>
                        <Box className="titulo-simulacao">Taxa prevista*</Box>
                        <Box className="valor-simulacao">
                          {moneyFullFormat(dadosSimulacaoResumo.FATOR, true)}%
                        </Box>
                      </Grid>
                      <Grid item xs={12} md={3}>
                        <Box className="titulo-simulacao">Valor máximo previsto*</Box>
                        <Box className="valor-simulacao-valor">
                          {dadosSimulacaoResumo.QTDTITULOS > 0
                            ? moneyFullFormat(dadosSimulacaoResumo.VLRLIQUIDO)
                            : '- -'}
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>
                </Box>
              </Box>
            </Box>
          )}

          {loadingSimulacao && (
            <Box className="simulacao-card">
              <Box className="simulacao-card-content">
                <Box className="box-titulo-simulacao mt-4">
                  <Skeleton
                    className="skeleton-custom mt-3"
                    animation="wave"
                    variant="rectangular"
                    width={240}
                    height={32}
                  />
                </Box>
                <Box className="box-itens mt-4">
                  <Grid container>
                    <Grid item xs={12} md={3}>
                      <Skeleton
                        className="skeleton-custom"
                        animation="wave"
                        variant="rectangular"
                        width="90%"
                        height={32}
                      />
                    </Grid>
                    <Grid item xs={12} md={2}>
                      <Skeleton
                        className="skeleton-custom"
                        animation="wave"
                        variant="rectangular"
                        width="90%"
                        height={32}
                      />
                    </Grid>
                    <Grid item xs={12} md={2}>
                      <Skeleton
                        className="skeleton-custom"
                        animation="wave"
                        variant="rectangular"
                        width="90%"
                        height={32}
                      />
                    </Grid>
                    <Grid item xs={12} md={2}>
                      <Skeleton
                        className="skeleton-custom"
                        animation="wave"
                        variant="rectangular"
                        width="90%"
                        height={32}
                      />
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <Skeleton
                        className="skeleton-custom"
                        animation="wave"
                        variant="rectangular"
                        width="90%"
                        height={32}
                      />
                    </Grid>
                  </Grid>
                </Box>
              </Box>
            </Box>
          )}
        </Grid>

        <Grid item xs={12} md={12} className="grid-simulacao-card">
          {!loadingSimulacao && <Box className="box-label-superior">RESUMO DA SELEÇÃO</Box>}
          {loadingSimulacao && (
            <Box className="box-label-superior">
              <Skeleton
                className="skeleton-custom"
                animation="wave"
                variant="rectangular"
                width="80%"
                height={40}
              />
            </Box>
          )}
        </Grid>
      </Grid>
    </Box>
  );
};

export default memo(SimulacaoBox);
